export default "__VITE_ASSET__Ct6eWf3i__"